export interface Partner {
  name: string
  url: string
  description: string
  /** Optional logo under public/partners/ - decorative next to the name, so no alt text needed. */
  logo?: string
}

/** Backlink-exchange partners - deliberately curated, not a general link directory (Google's
 *  guidelines flag "excessive link exchanges" as a link scheme; a handful of genuine mutual
 *  recommendations is normal, a long list of unrelated reciprocal links is not). Text taken
 *  verbatim as agreed with each partner rather than translated - the exact wording is usually
 *  part of the exchange agreement. See components/shared/PartnerPage.tsx. */
export const PARTNERS: Partner[] = [
  {
    name: 'Dawid Troska',
    url: 'https://dawid-troska.com/',
    description: 'Technical consulting by Dawid Troska — Cloud Consulting · AI-powered productivity and automation',
  },
  {
    name: 'AKSORT',
    url: 'https://aksort.ai/',
    description:
      'Gemeinsam finden wir heraus, welche Routineaufgaben sich bei Ihnen automatisieren lassen – und planen einen ersten konkreten Schritt.',
    logo: '/partners/aksort.svg',
  },
]
